import merge from 'lodash/merge';
import $api from '@/api';
import { normalizeRelations } from './helpers';

const state = () => ({
  allIds: [],
  byId: {}
});

const getters = {
  find: (state, _, __, rootGetters) => id => {
    const deal = state.byId[id];
    if (!deal) return null;

    return {
      ...deal,
      order_deals: rootGetters['orderDeals/getOrderDealsByDeal'](deal)
    };
  },

  findAll: (_, getters) => ids =>
    getters.list.filter(deal => ids.includes(deal.id)) || [],

  getGamifiedDealsWithOrders: (_, getters) =>
    getters.list.filter(
      deal =>
        deal?.use_points &&
        deal?.order_deals &&
        deal.order_deals.length
    ) || [],

  hasGamifiedDealsWithOrders: (_, getters) =>
    getters.getGamifiedDealsWithOrders.length || null,

  list: (state, getters) =>
    state.allIds.map(id => getters.find(id))
};

const actions = {
  addDeals({ commit, dispatch }, deals) {
    deals?.forEach(deal => {
      commit('add', normalizeRelations(deal, ['order_deals']));
    });
    dispatch('progressTracker/initializeProgressTracker', null, { root: true });
  },

  async getPoints({ commit }, { dealId, partnerUser }) {
    const { data } = await $api.points.getPoints({
      partnerUser,
      params: { dealId }
    });

    commit('setPoints', {
      dealId,
      currentPoints: data.current_points
    });
  }
}

const mutations = {
  add(state, deal) {
    if (!state.allIds.includes(deal.id)) {
      state.byId[deal.id] = deal;
      state.allIds.push(deal.id);
    } else {
      state.byId[deal.id] = merge(
        {},
        state.byId[deal.id],
        deal
      );
    }
  },

  setPoints(state, { dealId, currentPoints }) {
    if (state.byId[dealId]) {
      state.byId[dealId].current_points = currentPoints;
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
